import React, { useEffect, useState } from "react";
import {
  Badge,
  Box,
  Button,
  Divider,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  FormControl,
  FormLabel,
  Grid,
  GridItem,
  Heading,
  Image,
  Input,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Skeleton,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
  useColorModeValue,
  useDisclosure,
  useStyleConfig,
  useToast,
  Textarea,
} from "@chakra-ui/react";
import fetcher from "../../../../lib/fetcher";
import moment from "moment";
import { Player } from "@lottiefiles/react-lottie-player";
import jsPDF from "jspdf";
import {
  MdArrowDropDown,
  MdCall,
  MdContentCopy,
  MdOutlineEditNote,
  MdRotateRight,
  MdDownload,
  MdZoomIn,
  MdZoomOut,
  MdPictureAsPdf,
  MdLock,
  MdLockOpen,
} from "react-icons/md";
import { createTheme } from "react-data-table-component";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { AiOutlineDeploymentUnit } from "react-icons/ai";
import "react-vertical-timeline-component/style.min.css";

import nationalities from "./nationality.json";

import { useSalesPerson, useStatus } from "../../../../lib/hooks";
import { mutate } from "swr";
import { useAuth0 } from "@auth0/auth0-react";

function OrderDrawer({
  isOpen,
  onOpen,
  onClose,
  selectedOrder,
  onUpdate,
  setSelectedOrder,
}) {
  const toast = useToast();
  const [orderDetails, setOrderDetails] = useState({});
  const [userDetails, setUserDetails] = useState({});
  const [paymentDetails, setPaymentDetails] = useState([]);
  const [historyOrder, setHistoryOrder] = useState([]);
  const [invoiceDetails, setInvoiceDetails] = useState([]);
  const [salesAgentUpdate, setSalesAgentUpdate] = useState("");
  const [orderStatusUpdate, setOrderStatusUpdate] = useState("");
  const [userUpdate, setUserUpdate] = useState("");
  const [loading, setLoading] = useState(true);
  const {
    isOpen: eidOpen,
    onOpen: onEidOpen,
    onClose: onEidClose,
  } = useDisclosure();
  const { status, isLoading, isError } = useStatus(true);
  const {
    salesPerson,
    isLoading: salesPersonLoading,
    isError: salesPersonError,
  } = useSalesPerson(orderDetails?.salesAgentCode);

  const [audioAsset, setAudioAsset] = useState("");
  const [eidName, setEidName] = useState("");
  const [eidNationality, setEidNationality] = useState("");
  const [eidDOB, setEidDOB] = useState("");
  const [eidGender, setEidGender] = useState("");
  const [eidExpiry, setEidExpiry] = useState("");
  const [orderUpdate, setOrderUpdate] = useState(false);

  const [audio] = useState(new Audio(audioAsset));
  const styles = useStyleConfig("Card");
  const bgBox = useColorModeValue("#F4F8FE", "rgb(10, 20, 54)");
  const textColor = useColorModeValue("#000", "white");
  const InputBox = useColorModeValue("white", "rgb(10, 20, 54)");

  const [frontRotation, setFrontRotation] = useState(0);
  const [backRotation, setBackRotation] = useState(0);
  const [frontZoom, setFrontZoom] = useState(1);
  const [backZoom, setBackZoom] = useState(1);
  const [frontPanOffset, setFrontPanOffset] = useState({ x: 0, y: 0 });
  const [backPanOffset, setBackPanOffset] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState({ x: 0, y: 0 });

  const timeLineBox = useColorModeValue("#DDD", "rgb(10, 20, 54)");
  let token = localStorage.getItem("auth0_token");
  const initialRef = React.useRef();
  const finalRef = React.useRef();

  const { user, buildLogoutUrl } = useAuth0();

  const userRole = user?.["https://admin.b2connect.me/roles"][0];

  const {
    isOpen: isFrontOpen,
    onOpen: onFrontOpen,
    onClose: onFrontClose,
  } = useDisclosure();

  const {
    isOpen: isBackOpen,
    onOpen: onBackOpen,
    onClose: onBackClose,
  } = useDisclosure();

  const [confirmationComment, setConfirmationComment] = useState("");
  const {
    isOpen: isConfirmOpen,
    onOpen: onConfirmOpen,
    onClose: onConfirmClose,
  } = useDisclosure();

  // Lock/Unlock states
  const [lockUnlockLoading, setLockUnlockLoading] = useState(false);
  const [lockMessage, setLockMessage] = useState("");
  const [unlockMessage, setUnlockMessage] = useState("");
  const {
    isOpen: isLockConfirmOpen,
    onOpen: onLockConfirmOpen,
    onClose: onLockConfirmClose,
  } = useDisclosure();
  const {
    isOpen: isUnlockConfirmOpen,
    onOpen: onUnlockConfirmOpen,
    onClose: onUnlockConfirmClose,
  } = useDisclosure();

  // Address update modal states
  const {
    isOpen: isAddressOpen,
    onOpen: onAddressOpen,
    onClose: onAddressClose,
  } = useDisclosure();
  const [addressUpdate, setAddressUpdate] = useState({
    userZone: "",
    userZoneState: "",
    userAddress: "",
  });

  createTheme("solarized", {
    background: {
      default: "transparent",
    },
    text: {
      primary: "#268bd2",
      secondary: "#2aa198",
    },
  });

  const handleDrawerClose = () => {
    setOrderDetails({});
    setUserDetails({});
    setPaymentDetails([]);
    setHistoryOrder([]);
    setInvoiceDetails([]);
    setSalesAgentUpdate("");
    setOrderStatusUpdate("");
    setEidName("");
    setEidNationality("");
    setEidDOB("");
    setEidGender("");
    setEidExpiry("");
    setAudioAsset("");
    setSelectedOrder({});
    setFrontRotation(0);
    setBackRotation(0);
    setFrontZoom(1);
    setBackZoom(1);
    setFrontPanOffset({ x: 0, y: 0 });
    setBackPanOffset({ x: 0, y: 0 });
    setConfirmationComment("");
    setAddressUpdate({
      userZone: "",
      userZoneState: "",
      userAddress: "",
    });
    onClose();
  };
  const copyData = (text) => {
    navigator.clipboard.writeText(text).then(() => {
      toast({
        title: "Text Copied.",
        description: "",
        position: "top-right",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    });
  };

  const downloadImage = (base64Data, filename) => {
    const link = document.createElement("a");
    link.href = `data:image/jpeg;base64,${base64Data}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    toast({
      title: "Image Downloaded.",
      description: "",
      position: "top-right",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  };

  const downloadEIDPDF = async () => {
    const pdf = new jsPDF();
    const emiratesId = userDetails?.emiratesProfile?.emiratesId || "unknown";

    // Function to add image to PDF with Promise
    const addImageToPDF = (base64Data, pageTitle) => {
      return new Promise((resolve, reject) => {
        const imgData = `data:image/jpeg;base64,${base64Data}`;

        // Calculate dimensions to fit the page while maintaining aspect ratio
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const margin = 20;
        const maxWidth = pageWidth - margin * 2;
        const maxHeight = pageHeight - margin * 3 - 20; // Extra space for title

        // Create a temporary image to get dimensions
        const img = new window.Image();
        img.onload = function () {
          try {
            const imgWidth = this.width;
            const imgHeight = this.height;

            // Calculate scaling factor
            const scaleX = maxWidth / imgWidth;
            const scaleY = maxHeight / imgHeight;
            const scale = Math.min(scaleX, scaleY);

            const finalWidth = imgWidth * scale;
            const finalHeight = imgHeight * scale;

            // Center the image
            const x = (pageWidth - finalWidth) / 2;
            const y = margin + 20; // Space for title

            // Add title
            pdf.setFontSize(16);
            pdf.text(pageTitle, pageWidth / 2, margin, { align: "center" });

            // Add image
            pdf.addImage(imgData, "JPEG", x, y, finalWidth, finalHeight);
            resolve();
          } catch (error) {
            reject(error);
          }
        };
        img.onerror = () => reject(new Error("Failed to load image"));
        img.src = imgData;
      });
    };

    try {
      const images = [];

      // Add front image if available
      if (userDetails?.emiratesProfile?.eidaFrontBase64) {
        images.push({
          data: userDetails.emiratesProfile.eidaFrontBase64,
          title: `EID Front - ${emiratesId}`,
        });
      }

      // Add back image if available
      if (userDetails?.emiratesProfile?.eidaBackBase64) {
        images.push({
          data: userDetails.emiratesProfile.eidaBackBase64,
          title: `EID Back - ${emiratesId}`,
        });
      }

      if (images.length === 0) {
        toast({
          title: "No EID Images Found.",
          description: "No EID images available to download.",
          position: "top-right",
          status: "warning",
          duration: 2000,
          isClosable: true,
        });
        return;
      }

      // Process images sequentially
      for (let i = 0; i < images.length; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        await addImageToPDF(images[i].data, images[i].title);
      }

      // Save the PDF
      pdf.save(`EID_${emiratesId}.pdf`);

      toast({
        title: "PDF Downloaded.",
        description: "EID images have been saved as PDF.",
        position: "top-right",
        status: "success",
        duration: 2000,
        isClosable: true,
      });
    } catch (error) {
      console.error("Error generating PDF:", error);
      toast({
        title: "PDF Generation Failed.",
        description: "Please try again or contact support.",
        position: "top-right",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleImageWheel = (e, isBack = false) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? -0.1 : 0.1;

    if (isBack) {
      setBackZoom((prevZoom) => {
        const newZoom = Math.min(Math.max(prevZoom + delta, 0.5), 3);
        if (newZoom === 1) {
          setBackPanOffset({ x: 0, y: 0 });
        }
        return newZoom;
      });
    } else {
      setFrontZoom((prevZoom) => {
        const newZoom = Math.min(Math.max(prevZoom + delta, 0.5), 3);
        if (newZoom === 1) {
          setFrontPanOffset({ x: 0, y: 0 });
        }
        return newZoom;
      });
    }
  };

  const handleMouseDown = (e, isBack = false) => {
    const zoom = isBack ? backZoom : frontZoom;
    if (zoom > 1) {
      setIsDragging(true);
      setDragStart({
        x: e.clientX - (isBack ? backPanOffset.x : frontPanOffset.x),
        y: e.clientY - (isBack ? backPanOffset.y : frontPanOffset.y),
      });
    }
  };

  const handleMouseMove = (e, isBack = false) => {
    if (isDragging) {
      const newOffset = {
        x: e.clientX - dragStart.x,
        y: e.clientY - dragStart.y,
      };

      if (isBack) {
        setBackPanOffset(newOffset);
      } else {
        setFrontPanOffset(newOffset);
      }
    }
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const fetchOrder = async () => {
    setLoading(true);
    try {
      const order = await fetcher(`orders/${selectedOrder?.orderId}`);
      const user = await fetcher(`orders/${selectedOrder?.orderId}/user`);
      const invoice = await fetcher(`orders/${selectedOrder?.orderId}/invoice`);

      const payments = await fetcher(
        `orders/${selectedOrder?.orderId}/payments`
      );

      const orderHistory = await fetcher(
        `orders/${selectedOrder?.orderId}/history`
      );

      if (orderHistory?.success && orderHistory?.body) {
        setHistoryOrder(orderHistory?.body);
      }
      if (order?.success && order?.body) {
        setOrderDetails(order.body);
      }
      if (user?.success && user?.body) {
        setUserDetails(user?.body);
      }
      if (payments?.success && payments?.body) {
        setPaymentDetails(payments?.body);
      }

      if (invoice?.success && invoice?.body && invoiceDetails.length == 0) {
        setInvoiceDetails([invoice?.body]);
      }
      setLoading(false);
    } catch (e) {
      // console.log(e);
    }
  };

  const handelOrderUpdate = async () => {
    const statusToUpdate = orderStatusUpdate || orderDetails.status;

    let authToken = localStorage.getItem("auth0_token");

    const orderUpdate = await fetch(
      process.env.REACT_APP_BASE_URL + `/orders/${selectedOrder?.orderId}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          salesAgentCode: salesAgentUpdate
            ? salesAgentUpdate
            : orderDetails?.salesAgentCode,
          status: statusToUpdate,
          comment: confirmationComment,
          updatedBy: user?.email,
        }),
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      }
    );
    if (orderUpdate.status < 399) {
      audio.src = "/sounds/mail_sent.mp3";
      await audio.play();
      await mutate("orders/`", true);

      toast({
        title: "Order Updated.",
        description: "",
        position: "top-right",
        status: "success",
        duration: 2000,
        isClosable: true,
      });

      setConfirmationComment("");
      onConfirmClose();
      await fetchOrder();
    } else {
      audio.src = "/sounds/error.mp3";
      await audio.play();
      toast({
        title: "Something Went Wrong.",
        description: "Please try again later or reach out to the support team.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const eidUpdateHandler = async () => {
    let payload = {
      name: eidName || userDetails?.emiratesProfile?.name,
      sex: eidGender || userDetails?.emiratesProfile?.sex,
      dateOfBirth: moment(
        eidDOB || userDetails?.emiratesProfile?.dateOfBirth
      ).unix(),
      emiratesId: userDetails?.emiratesProfile?.emiratesId,
      expiryDate: moment(
        eidExpiry || userDetails?.emiratesProfile?.expiryDate
      ).unix(),
      nationality: eidNationality,
      eidaFrontBase64: userDetails?.emiratesProfile?.eidaFrontBase64,
      eidaBackBase64: userDetails?.emiratesProfile?.eidaBackBase64,
    };
    await fetch(
      `${process.env.REACT_APP_BASE_URL}/users/${userDetails?.id}/emirates-id`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    )
      .then(async (res) => {
        if (res.status < 399) {
          audio.src = "/sounds/mail_sent.mp3";
          await audio.play();
          setUserUpdate(payload);
          toast({
            title: "User EID Updated.",
            description: "",
            position: "top-right",
            status: "success",
            duration: 2000,
            isClosable: true,
          });
          onEidClose(true);
        } else {
          audio.src = "/sounds/error.mp3";
          await audio.play();
          toast({
            title: "Something Went Wrong.",
            description:
              "Please try again later or reach out to the support team.",
            status: "error",
            duration: 3000,
            isClosable: true,
          });
        }
      })
      .catch(async (e) => {
        audio.src = "/sounds/error.mp3";
        await audio.play();
        toast({
          title: "Something Went Wrong.",
          description:
            "Please try again later or reach out to the support team.",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };
  function capitalizeFirstLetter(string) {
    if (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  }
  useEffect(() => {
    // handleDrawerClose()
    fetchOrder();
  }, [userUpdate, selectedOrder, onClose]);

  const handleUpdateClick = () => {
    // Validation for approved status before showing confirmation modal
    const statusToUpdate = orderStatusUpdate || orderDetails.status;
    if (statusToUpdate === "approved") {
      if (!orderDetails?.userZone || !orderDetails?.userZoneState || !orderDetails?.userAddress) {
        toast({
          title: "Address Required",
          description: "Zone, State, and Address cannot be empty when changing status to approved.",
          position: "top-right",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }

      // Check if zone contains 'Ucopia' keyword
      if (orderDetails?.userZone && orderDetails.userZone.toLowerCase().includes('ucopia')) {
        toast({
          title: "Zone Update Required",
          description: "Zone has not been updated. Please select a zone that does not contain 'Ucopia' before approving.",
          position: "top-right",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
    }

    onConfirmOpen();
  };

  const handleConfirmUpdate = () => {
    handelOrderUpdate();
  };

  const handleCancelUpdate = () => {
    setConfirmationComment("");
    onConfirmClose();
  };

  // Address update handlers
  const handleAddressUpdateClick = () => {
    setAddressUpdate({
      userZone: orderDetails?.userZone || "",
      userZoneState: orderDetails?.userZoneState || "",
      userAddress: orderDetails?.userAddress || "",
    });
    onAddressOpen();
  };

  const handleAddressUpdate = async () => {
    // Validation
    if (!addressUpdate.userZone || !addressUpdate.userZoneState || !addressUpdate.userAddress) {
      toast({
        title: "Validation Error",
        description: "Zone, State, and Address are required fields.",
        position: "top-right",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    let authToken = localStorage.getItem("auth0_token");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/orders/${selectedOrder?.orderId}/address/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({
            userZone: addressUpdate.userZone,
            userZoneState: addressUpdate.userZoneState,
            userAddress: addressUpdate.userAddress,
          }),
        }
      );

      if (response.status < 399) {
        audio.src = "/sounds/mail_sent.mp3";
        await audio.play();
        
        toast({
          title: "Address Updated.",
          description: "Customer address information has been updated successfully.",
          position: "top-right",
          status: "success",
          duration: 2000,
          isClosable: true,
        });

        onAddressClose();
        await fetchOrder(); // Refresh the order data
      } else {
        audio.src = "/sounds/error.mp3";
        await audio.play();
        
        toast({
          title: "Update Failed.",
          description: "Failed to update address. Please try again or contact support.",
          position: "top-right",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      audio.src = "/sounds/error.mp3";
      await audio.play();
      
      toast({
        title: "Something Went Wrong.",
        description: "Please try again later or reach out to the support team.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleCancelAddressUpdate = () => {
    setAddressUpdate({
      userZone: "",
      userZoneState: "",
      userAddress: "",
    });
    onAddressClose();
  };

  // Generate default lock message
  const getDefaultLockMessage = () => {
    // Find the next unpaid or overdue installment
    const unpaidInstallment = orderDetails?.installmentInfo?.find(
      (inst) => inst?.status !== "PAID"
    );
    const amount = unpaidInstallment?.price || orderDetails?.total || "0.00";
    const invoiceNumber = invoiceDetails[0]?.invoiceNumber || orderDetails?.invoiceNo || "N/A";

    return `This device is locked due to non-payment of AED ${amount}. Please make a payment at the B2 Sales Point or Kiosk, or through the B2Connect Mobile app to continue using your phone. Invoice Number: ${invoiceNumber}`;
  };

  // Show lock confirmation modal
  const handleLockClick = () => {
    setLockMessage(getDefaultLockMessage());
    onLockConfirmOpen();
  };

  // Show unlock confirmation modal
  const handleUnlockClick = () => {
    setUnlockMessage("Your phone has been unlocked");
    onUnlockConfirmOpen();
  };

  // Lock/Unlock handlers
  const handleLockDevice = async () => {
    onLockConfirmClose();
    setLockUnlockLoading(true);
    let authToken = localStorage.getItem("auth0_token");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/knox/lock`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({
            orderId: selectedOrder?.orderId,
            message: lockMessage,
            by: user?.email,
          }),
        }
      );

      if (response.status < 399) {
        audio.src = "/sounds/mail_sent.mp3";
        await audio.play();

        toast({
          title: "Device Locked.",
          description: "The device has been locked successfully.",
          position: "top-right",
          status: "success",
          duration: 2000,
          isClosable: true,
        });

        await fetchOrder();
      } else {
        audio.src = "/sounds/error.mp3";
        await audio.play();

        toast({
          title: "Lock Failed.",
          description: "Failed to lock the device. Please try again or contact support.",
          position: "top-right",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      audio.src = "/sounds/error.mp3";
      await audio.play();

      toast({
        title: "Something Went Wrong.",
        description: "Please try again later or reach out to the support team.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLockUnlockLoading(false);
    }
  };

  const handleUnlockDevice = async () => {
    onUnlockConfirmClose();
    setLockUnlockLoading(true);
    let authToken = localStorage.getItem("auth0_token");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/knox/unlock`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
          body: JSON.stringify({
            orderId: selectedOrder?.orderId,
            message: unlockMessage,
            by: user?.email,
          }),
        }
      );

      if (response.status < 399) {
        audio.src = "/sounds/mail_sent.mp3";
        await audio.play();

        toast({
          title: "Device Unlocked.",
          description: "The device has been unlocked successfully.",
          position: "top-right",
          status: "success",
          duration: 2000,
          isClosable: true,
        });

        await fetchOrder();
      } else {
        audio.src = "/sounds/error.mp3";
        await audio.play();

        toast({
          title: "Unlock Failed.",
          description: "Failed to unlock the device. Please try again or contact support.",
          position: "top-right",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (error) {
      audio.src = "/sounds/error.mp3";
      await audio.play();

      toast({
        title: "Something Went Wrong.",
        description: "Please try again later or reach out to the support team.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLockUnlockLoading(false);
    }
  };

  // Zone options
  const zoneOptions = [
    "Al Dar",
    "Al Khail Gate",
    "B2 Office",
    "Citadel",
    "Dry Docks",
    "ECC 09",
    "ECC 22",
    "Ejadah",
    "EO",
    "Izone",
    "Jafza",
    "MGPI",
    "Maids CC",
    "Sawaeed",
    "Sharjah",
    "Tecom",
    "Wade Adams",
    "B2 Ucopia 1",
    "B2 Ucopia 2",
  ];

  // State options
  const stateOptions = [
    "DUBAI",
    "ABU_DHABI",
  ];

  return (
    <>
      {orderDetails && userDetails && (
        <>
          <Drawer onClose={handleDrawerClose} isOpen={isOpen} size={"full"}>
            <DrawerOverlay />
            <DrawerContent background={bgBox}>
              <DrawerCloseButton />
              <DrawerHeader>
                <Flex flexDir={"column"}>
                  <span>
                    {orderDetails?.salesOrderNo} (
                    {moment(orderDetails?.time).format(
                      "MMMM Do YYYY, h:mm:ss a"
                    )}
                    )
                  </span>
                  <span my={3} style={{ fontSize: 14, color: "gray" }}>
                    {orderDetails?.appPlatform &&
                      `Placed on ${capitalizeFirstLetter(
                        orderDetails?.appPlatform
                      )}`}{" "}
                    {orderDetails?.appVersion &&
                      `Version ${capitalizeFirstLetter(
                        orderDetails?.appVersion
                      )}`}
                  </span>
                  <Flex p={2} flexDir={"row"} justifyContent={"space-between"}>
                    <Skeleton
                      isLoaded={!loading}
                      fadeDuration={1.5}
                      borderRadius={20}
                    >
                      <Flex
                        flexDir={{ base: "column", md: "column", xl: "row" }}
                        alignSelf={"flex-end"}
                      >
                        <Flex>
                          <Menu>
                            <MenuButton
                              as={Button}
                              rightIcon={<MdArrowDropDown />}
                            >
                              {capitalizeFirstLetter(orderStatusUpdate) ||
                                capitalizeFirstLetter(orderDetails?.status) ||
                                "Select status"}
                            </MenuButton>
                            <MenuList>
                              {status?.body?.statuses?.map((item, i) => {
                                if (item != "initiated" && item != "created") {
                                  return (
                                    <MenuItem
                                      key={i}
                                      color={textColor}
                                      value={item}
                                      fontSize={14}
                                      onClick={(e) => {
                                        setOrderUpdate(true);
                                        setOrderStatusUpdate(e.target.value);
                                      }}
                                    >
                                      {capitalizeFirstLetter(item)}
                                    </MenuItem>
                                  );
                                }
                              })}
                            </MenuList>
                          </Menu>
                        </Flex>
                        <Flex>
                          <Input
                            placeholder="Sales Agent"
                            onChange={(e) => {
                              setSalesAgentUpdate(e.target.value);
                              setOrderUpdate(true);
                            }}
                            defaultValue={orderDetails?.salesAgentCode}
                            background={InputBox}
                            w={320}
                            my={{ base: 2, md: 2, xl: 0 }}
                            mx={{ base: 0, md: 0, xl: 2 }}
                            disabled={
                              userRole !== "ProductManager" &&
                              userRole !== "Admin"
                            }
                          />
                        </Flex>
                        <Flex>
                          <Button
                            onClick={handleUpdateClick}
                            disabled={!orderUpdate}
                          >
                            Update
                          </Button>
                        </Flex>
                        <Flex ml={2}>
                          <Menu>
                            <MenuButton
                              as={Button}
                              rightIcon={<MdArrowDropDown />}
                              isLoading={lockUnlockLoading}
                              colorScheme="orange"
                            >
                              Actions
                            </MenuButton>
                            <MenuList>
                              <MenuItem
                                icon={<MdLock />}
                                onClick={handleLockClick}
                                isDisabled={lockUnlockLoading}
                              >
                                Lock Device
                              </MenuItem>
                              <MenuItem
                                icon={<MdLockOpen />}
                                onClick={handleUnlockClick}
                                isDisabled={lockUnlockLoading}
                              >
                                Unlock Device
                              </MenuItem>
                            </MenuList>
                          </Menu>
                        </Flex>
                      </Flex>
                    </Skeleton>
                  </Flex>
                </Flex>
              </DrawerHeader>
              <DrawerBody>
                <Grid
                  templateRows={{
                    base: "repeat(1, 2fr)",
                    md: "repeat(1, 2fr)",
                    lg: "repeat(1, 1fr)",
                    "2xl": "repeat(1, 1fr)",
                  }}
                  templateColumns={{
                    base: "repeat(1, 1fr)",
                    md: "repeat(2, 2fr)",
                    lg: "repeat(4, 2fr)",
                    "2xl": "repeat(5, 2fr)",
                  }}
                  gap="20px"
                >
                  <GridItem colSpan={{ base: 4, md: 3, lg: 3, "2xl": 4 }}>
                    <Skeleton
                      isLoaded={!loading}
                      fadeDuration={1.5}
                      borderRadius={20}
                    >
                      <Flex __css={styles} mb={3} flexDirection={"column"}>
                        <Flex
                          flexDirection={"row"}
                          justifyContent={"space-between"}
                        >
                          <Flex>
                            <Player
                              autoplay
                              loop
                              src="https://assets10.lottiefiles.com/packages/lf20_504lfkem.json"
                              style={{ height: "32px", width: "32px" }}
                            ></Player>
                            <Heading mt={1} ml={2} size={"md"} fontWeight={600}>
                              Items ({orderDetails?.items?.length})
                            </Heading>
                          </Flex>
                          {orderDetails?.isAddon && (
                            <>
                              <Flex flexDir={"row"} alignItems={"center"}>
                                <Flex>
                                  <Text color={"#e24379"}>WIFI Addon</Text>
                                </Flex>
                              </Flex>
                            </>
                          )}
                        </Flex>

                        {orderDetails?.items?.map((item, i) => (
                          <Flex
                            key={i}
                            flexDir={["column", "column", "row"]}
                            p={3}
                          >
                            <Flex>
                              <Image
                                src={item.images[0]}
                                width={20}
                                height={20}
                                borderRadius={10}
                              />
                            </Flex>
                            <Flex ml={4} flexDirection={"row"}>
                              <Flex flexDir={["column", "column", "column"]}>
                                {item.name && (
                                  <Text fontSize={"lg"} fontWeight={600}>
                                    {item.name}
                                  </Text>
                                )}

                                {item.sku && (
                                  <Text
                                    fontSize={"sm"}
                                    fontWeight={500}
                                    color={"gray"}
                                  >
                                    SKU: {item.sku}
                                  </Text>
                                )}

                                <Flex
                                  flexDir={"row"}
                                  justifyContent={"space-between"}
                                >
                                  {item.offerId && (
                                    <Text
                                      fontSize={"sm"}
                                      fontWeight={500}
                                      color={"gray"}
                                    >
                                      Offer ID: {item.offerId}
                                    </Text>
                                  )}
                                  {orderDetails?.salesAgentCode && (
                                    <Text
                                      fontSize={"sm"}
                                      fontWeight={500}
                                      color={"gray"}
                                    >
                                      Sales Agent:{" "}
                                      {orderDetails?.salesAgentCode}
                                    </Text>
                                  )}
                                </Flex>
                              </Flex>
                            </Flex>
                          </Flex>
                        ))}
                      </Flex>
                    </Skeleton>
                  </GridItem>

                  <GridItem
                    rowSpan={4}
                    colSpan={{ base: 4, md: 1, lg: 1, "2xl": 1 }}
                  >
                    <Skeleton
                      isLoaded={!loading}
                      fadeDuration={1.5}
                      borderRadius={20}
                    >
                      <Flex
                        position={"sticky"}
                        flexDir={"column"}
                        __css={styles}
                        sx={{
                          position: "sticky",

                          top: "0",
                        }}
                      >
                        <Flex p={4} flexDir={"column"}>
                          <Flex flexDir={"column"} mb={3}>
                            <Flex>
                              <Heading size={"sm"}>CUSTOMER</Heading>
                            </Flex>
                          </Flex>

                          <Flex>
                            <Flex flexDir={"column"}>
                              <Flex>
                                <Text>
                                  {userDetails[0]?.firstName}{" "}
                                  {userDetails[0]?.lastName}
                                </Text>
                              </Flex>
                            </Flex>
                          </Flex>

                          <Divider pt={2} orientation="horizontal" />
                        </Flex>

                        <Flex p={4} flexDir={"column"}>
                          <Flex flexDir={"column"} mb={3}>
                            <Flex>
                              <Heading size={"sm"}>Contact Information</Heading>
                            </Flex>
                          </Flex>

                          <Flex
                            flexDir={"row"}
                            justifyContent={"space-between"}
                          >
                            <Text fontSize={13}>
                              {userDetails?.contactPhone
                                ? userDetails.contactPhone
                                : "No user phone number"}
                            </Text>
                            <Flex>
                              {userDetails?.contactPhone ? (
                                <Flex
                                  flexDir={"row"}
                                  justifyContent={"space-between"}
                                >
                                  <Flex
                                    pr={3}
                                    cursor={"pointer"}
                                    onClick={() =>
                                      copyData(userDetails?.contactPhone)
                                    }
                                  >
                                    <Link
                                      href={`to:${userDetails?.contactPhone}`}
                                      target={"_blank"}
                                    >
                                      <MdCall />
                                    </Link>
                                  </Flex>
                                  <Flex
                                    cursor={"pointer"}
                                    onClick={() =>
                                      copyData(userDetails?.contactPhone)
                                    }
                                  >
                                    <MdContentCopy />
                                  </Flex>
                                </Flex>
                              ) : null}
                            </Flex>
                          </Flex>

                          <Flex
                            flexDir={"row"}
                            justifyContent={"space-between"}
                            pt={2}
                          >
                            <Text fontSize={13}>
                              {userDetails?.email
                                ? userDetails?.email
                                : "No user email"}
                            </Text>
                            <Flex>
                              {userDetails?.email ? (
                                <Flex
                                  cursor={"pointer"}
                                  onClick={() => copyData(userDetails?.email)}
                                >
                                  <MdContentCopy />
                                </Flex>
                              ) : null}
                            </Flex>
                          </Flex>
                          <Divider pt={2} orientation="horizontal" />
                        </Flex>

                        <Flex p={4} flexDir={"column"}>
                          <Flex flexDir={"column"} mb={3}>
                            <Flex flexDir={"row"}>
                              <Heading size={"sm"}>Customer Address Info</Heading>
                              <Flex
                                ml={3}
                                cursor={"pointer"}
                                onClick={handleAddressUpdateClick}
                              >
                                <MdOutlineEditNote size={22} />
                              </Flex>
                            </Flex>
                          </Flex>

                          <Flex
                            flexDir={"column"}
                            justifyContent={"space-between"}
                          >
                            <Flex
                              flexDir={"row"}
                              justifyContent={"space-between"}
                              mb={3}
                            >
                              <Flex flexDir={"column"}>
                                <Text color={"gray"} fontSize={"sm"}>
                                  ZONE
                                </Text>
                                <Text>
                                  {orderDetails?.userZone || "Not Provided"}
                                </Text>
                              </Flex>
                              <Flex flexDir={"column"}>
                                <Text color={"gray"} fontSize={"sm"}>
                                  STATE
                                </Text>
                                <Text>
                                  {orderDetails?.userZoneState || "Not Provided"}
                                </Text>
                              </Flex>
                            </Flex>
                            
                            <Flex flexDir={"column"} mb={3}>
                              <Text color={"gray"} fontSize={"sm"}>
                                ADDRESS
                              </Text>
                              <Text>
                                {orderDetails?.userAddress || "Not Provided"}
                              </Text>
                            </Flex>
                          </Flex>
                          
                          <Divider pt={2} orientation="horizontal" />
                        </Flex>

                        <Flex>
                          <Modal
                            initialFocusRef={initialRef}
                            finalFocusRef={finalRef}
                            isOpen={eidOpen}
                            onClose={onEidClose}
                          >
                            <ModalOverlay />
                            <ModalContent>
                              <ModalHeader>EID Details</ModalHeader>
                              <ModalCloseButton />
                              <ModalBody pb={6}>
                                <Flex>
                                  <FormControl>
                                    <FormLabel>First name</FormLabel>
                                    <Input
                                      color={textColor}
                                      placeholder="Name"
                                      defaultValue={
                                        userDetails?.emiratesProfile?.name
                                      }
                                      onChange={(e) =>
                                        setEidName(e.target.value)
                                      }
                                    />
                                  </FormControl>
                                  <FormControl ml={4}>
                                    <FormLabel>Nationality</FormLabel>
                                    <Select
                                      color={textColor}
                                      placeholder={"Nationality"}
                                      onChange={(e) =>
                                        setEidNationality(e.target.value)
                                      }
                                    >
                                      {nationalities.map((item, i) => (
                                        <option
                                          key={i}
                                          value={item.name}
                                          selected={
                                            item.name ===
                                            userDetails?.emiratesProfile
                                              ?.nationality
                                          }
                                        >
                                          {item.name.toUpperCase()}
                                        </option>
                                      ))}
                                    </Select>
                                  </FormControl>
                                </Flex>

                                <Flex>
                                  <FormControl mt={4}>
                                    <FormLabel>Gender</FormLabel>
                                    <Select
                                      placeholder={"Select Gender"}
                                      onChange={(e) =>
                                        setEidGender(e.target.value)
                                      }
                                    >
                                      <option
                                        selected={
                                          userDetails?.emiratesProfile?.sex ==
                                          "MALE"
                                        }
                                        value="MALE"
                                      >
                                        Male
                                      </option>
                                      <option
                                        selected={
                                          userDetails?.emiratesProfile?.sex ===
                                          "FEMALE"
                                        }
                                        value="FEMALE"
                                      >
                                        Female
                                      </option>
                                    </Select>
                                  </FormControl>
                                  <FormControl mt={4} ml={4}>
                                    <FormLabel>EID Number</FormLabel>
                                    <Input
                                      color={textColor}
                                      placeholder="EID Number"
                                      value={
                                        userDetails?.emiratesProfile?.emiratesId
                                      }
                                      disabled
                                    />
                                  </FormControl>
                                </Flex>
                                <FormControl mt={4}>
                                  <FormLabel>Date of Birth</FormLabel>
                                  <Input
                                    type={"date"}
                                    defaultValue={moment(
                                      userDetails?.emiratesProfile?.dateOfBirth
                                    ).calendar()}
                                    onChange={(e) => setEidDOB(e.target.value)}
                                  />
                                </FormControl>
                                <FormControl mt={4}>
                                  <FormLabel>Expiry Date</FormLabel>
                                  <Input
                                    type={"date"}
                                    defaultValue={moment(
                                      userDetails?.emiratesProfile?.expiryDate
                                    ).calendar()}
                                    onChange={(e) =>
                                      setEidExpiry(e.target.value)
                                    }
                                  />
                                </FormControl>
                              </ModalBody>

                              <ModalFooter>
                                <Button
                                  colorScheme="pink"
                                  mr={3}
                                  onClick={eidUpdateHandler}
                                >
                                  Update
                                </Button>
                                <Button onClick={onEidClose}>Cancel</Button>
                              </ModalFooter>
                            </ModalContent>
                          </Modal>
                        </Flex>
                        <Flex p={4} flexDir={"column"}>
                          <Flex flexDir={"column"} mb={3}>
                            <Flex flexDir={"row"}>
                              <Heading size={"sm"}>EID Details</Heading>
                              <Flex
                                ml={3}
                                cursor={"pointer"}
                                onClick={onEidOpen}
                              >
                                <MdOutlineEditNote size={22} />
                              </Flex>
                            </Flex>
                          </Flex>

                          <Flex
                            flexDir={"column"}
                            justifyContent={"space-between"}
                          >
                            <Flex
                              flexDir={"row"}
                              justifyContent={"space-between"}
                            >
                              <Flex flexDir={"column"}>
                                <Text color={"gray"} fontSize={"sm"}>
                                  NAME
                                </Text>
                                <Text>
                                  {userDetails?.emiratesProfile?.name ||
                                    "Not Provided"}
                                </Text>
                              </Flex>
                              <Flex flexDir={"column"}>
                                <Text color={"gray"} fontSize={"sm"}>
                                  NATIONALITY
                                </Text>
                                <Text>
                                  {userDetails?.emiratesProfile?.nationality ||
                                    "Not Provided"}
                                </Text>
                              </Flex>
                            </Flex>

                            <Flex
                              flexDir={"column"}
                              justifyContent={"space-between"}
                              my={3}
                            >
                              <Flex flexDir={"column"} my={3}>
                                <Text color={"gray"} fontSize={"sm"}>
                                  EID NUMBER
                                </Text>
                                <Text>
                                  {userDetails?.emiratesProfile?.emiratesId ||
                                    "Not Provided"}
                                </Text>
                              </Flex>
                              <Flex flexDir={"column"}>
                                <Text color={"gray"} fontSize={"sm"}>
                                  GENDER
                                </Text>
                                <Text>
                                  {userDetails?.emiratesProfile?.sex ||
                                    "Not Provided"}
                                </Text>
                              </Flex>
                            </Flex>

                            <Flex
                              flexDir={"row"}
                              justifyContent={"space-between"}
                              my={2}
                            >
                              <Flex flexDir={"column"}>
                                <Text color={"gray"} fontSize={"sm"}>
                                  DATE OF BIRTHDAY
                                </Text>
                                <Text>
                                  {userDetails?.emiratesProfile?.dateOfBirth
                                    ? moment(
                                        userDetails?.emiratesProfile
                                          ?.dateOfBirth
                                      ).format("LL")
                                    : "Not provided"}
                                </Text>
                              </Flex>
                              <Flex flexDir={"column"}>
                                <Text color={"gray"} fontSize={"sm"}>
                                  EXPIRY
                                </Text>
                                <Text>
                                  {moment(
                                    userDetails?.emiratesProfile?.expiryDate
                                  ).format("LL")}
                                </Text>
                              </Flex>
                            </Flex>
                            {userDetails?.emiratesProfile?.eidaFrontBase64 && (
                              <Flex flexDir={"column"} my={2}>
                                <Text color={"gray"} fontSize={"sm"}>
                                  EID FRONT
                                </Text>
                                <Image
                                  src={`data:image/jpeg;base64,${userDetails.emiratesProfile.eidaFrontBase64}`}
                                  alt="EID Front"
                                  height="auto"
                                  width="auto"
                                  borderRadius="md"
                                  cursor="pointer"
                                  onClick={onFrontOpen}
                                />
                              </Flex>
                            )}

                            {userDetails?.emiratesProfile?.eidaBackBase64 && (
                              <Flex flexDir={"column"} my={2}>
                                <Text color={"gray"} fontSize={"sm"}>
                                  EID BACK
                                </Text>
                                <Image
                                  src={`data:image/jpeg;base64,${userDetails.emiratesProfile.eidaBackBase64}`}
                                  alt="EID Back"
                                  height="auto"
                                  width="auto"
                                  borderRadius="md"
                                  cursor="pointer"
                                  onClick={onBackOpen}
                                />
                              </Flex>
                            )}
                            {(userDetails?.emiratesProfile?.eidaFrontBase64 ||
                              userDetails?.emiratesProfile?.eidaBackBase64) && (
                              <Flex flexDir={"column"} my={2}>
                                <Button
                                  onClick={downloadEIDPDF}
                                  leftIcon={<MdPictureAsPdf />}
                                  colorScheme="blue"
                                  variant="outline"
                                  size="sm"
                                  width="100%"
                                >
                                  Download EID as PDF
                                </Button>
                              </Flex>
                            )}
                            <Flex flexDir={"column"} my={4}>
                              <Text
                                fontSize={"sm"}
                                color={"gray"}
                                fontWeight={600}
                              >
                                {" "}
                                MAC ADDRESSES
                              </Text>
                            </Flex>
                            <Text whiteSpace="pre-line">
                              {userDetails?.mac_address
                                ? userDetails.mac_address.split(",").join("\n")
                                : "Not Provided"}
                            </Text>
                            <Flex flexDir={"column"} my={4}>
                              <Text
                                fontSize={"sm"}
                                color={"gray"}
                                fontWeight={600}
                              >
                                GUARANTOR DETAILS
                              </Text>
                              <Flex flexDir="column" mt={2}>
                                {(() => {
                                  let guarantor = null;
                                  try {
                                    guarantor =
                                      userDetails?.guarantor &&
                                      typeof userDetails.guarantor === "string"
                                        ? JSON.parse(userDetails.guarantor)
                                        : null;
                                  } catch (e) {
                                    guarantor = null;
                                  }

                                  return (
                                    <>
                                      <FormControl mt={3}>
                                        <FormLabel>Guarantor Name</FormLabel>
                                        <Text>
                                          {guarantor?.guarantorName || "null"}
                                        </Text>
                                      </FormControl>
                                      <FormControl mt={3}>
                                        <FormLabel>Guarantor Phone</FormLabel>
                                        <Text>
                                          {guarantor?.guarantorPhone || "null"}
                                        </Text>
                                      </FormControl>
                                      <FormControl mt={3}>
                                        <FormLabel>Employer Name</FormLabel>
                                        <Text>
                                          {guarantor?.employerName || "null"}
                                        </Text>
                                      </FormControl>
                                      <FormControl mt={3}>
                                        <FormLabel>Camp Boss Name</FormLabel>
                                        <Text>
                                          {guarantor?.campBossName || "null"}
                                        </Text>
                                      </FormControl>
                                    </>
                                  );
                                })()}
                              </Flex>
                            </Flex>
                          </Flex>
                        </Flex>
                      </Flex>
                    </Skeleton>
                  </GridItem>

                  <GridItem
                    rowSpan={1}
                    colSpan={{ base: 4, md: 2, lg: 3, "2xl": 2 }}
                  >
                    <Skeleton
                      isLoaded={!loading}
                      fadeDuration={1.5}
                      borderRadius={20}
                    >
                      <Flex __css={styles}>
                        <Flex p={1} flexDir={"column"}>
                          <Flex>
                            <Heading size={"sm"}>Order payment</Heading>
                          </Flex>
                          <Flex
                            pt={3}
                            flexDir={"row"}
                            justifyContent={"space-between"}
                          >
                            <Flex flexDir={"column"}>
                              <Text fontSize={"lg"}>Payment Type:</Text>
                              <Text fontSize={"sm"}>
                                {orderDetails?.paymentMethod}
                              </Text>
                            </Flex>
                            <Flex>
                              <Text fontSize={"lg"} fontWeight={900}>
                                Total AED {orderDetails?.total}
                              </Text>
                            </Flex>
                          </Flex>
                          {!salesPersonLoading &&
                            !salesPersonError &&
                            salesPerson?.length !== 0 && (
                              <Flex py={3}>
                                <Divider />
                              </Flex>
                            )}

                          {!salesPersonLoading &&
                            !salesPersonError &&
                            salesPerson?.length !== 0 && (
                              <Flex
                                pt={3}
                                flexDir={"row"}
                                justifyContent={"space-between"}
                              >
                                <Flex flexDir={"column"}>
                                  <Text fontSize={"lg"}>Sales Person:</Text>
                                  <Text fontSize={"sm"}>
                                    {" "}
                                    {salesPerson[0]?.salesperson_email}
                                  </Text>
                                  <Text fontSize={"sm"}>
                                    Status:{" "}
                                    {salesPerson[0]?.is_active
                                      ? "Active"
                                      : "InActive"}
                                  </Text>
                                </Flex>
                                <Flex>
                                  <Text fontSize={"lg"} color={"gray.600"}>
                                    {salesPerson[0]?.salesperson_name}
                                  </Text>
                                </Flex>
                              </Flex>
                            )}
                        </Flex>
                        {paymentDetails.length !== 0 && (
                          <Flex py={3}>
                            <Divider />
                          </Flex>
                        )}
                        {invoiceDetails.length !== 0 && invoiceDetails && (
                          <Box pt={3}>
                            <Flex flexDirection={"row"}>
                              <Player
                                autoplay
                                loop
                                src="https://assets10.lottiefiles.com/private_files/lf30_w41yuaao.json"
                                style={{ height: "32px", width: "32px" }}
                              ></Player>
                              <Heading
                                mt={1}
                                ml={2}
                                size={"sm"}
                                fontWeight={600}
                              >
                                Invoice
                              </Heading>
                            </Flex>
                            <TableContainer
                              sx={{
                                "&::-webkit-scrollbar": {
                                  width: "16px",
                                  borderRadius: "8px",
                                  backgroundColor: `rgba(0, 0, 0, 0.05)`,
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor: `rgba(0, 0, 0, 0.05)`,
                                  height: "5px",
                                  width: "5px",
                                },
                              }}
                            >
                              <Table variant="simple" overflow={"auto"}>
                                <Thead>
                                  <Tr>
                                    <Th>Customer Name</Th>
                                    <Th>Invoice Number</Th>
                                    <Th>Date</Th>
                                    <Th>Status</Th>
                                    <Th>Balance</Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {invoiceDetails?.map((item, index) => (
                                    <Tr key={index}>
                                      <Td>
                                        <Flex
                                          flexDir={"row"}
                                          justifyContent={"center"}
                                          alignItems={"center"}
                                        >
                                          <Flex>
                                            <Text>{item.customerName}</Text>
                                          </Flex>
                                        </Flex>
                                      </Td>
                                      <Td>
                                        <Flex
                                          flexDir={"row"}
                                          justifyContent={"center"}
                                          alignItems={"center"}
                                        >
                                          <Flex>
                                            <Text>{item.invoiceNumber}</Text>
                                          </Flex>
                                          <Flex
                                            ml={1}
                                            cursor={"pointer"}
                                            onClick={() =>
                                              copyData(item.invoiceNumber)
                                            }
                                          >
                                            <MdContentCopy />
                                          </Flex>
                                        </Flex>
                                      </Td>
                                      <Td>
                                        {" "}
                                        <Text>
                                          {item?.date
                                            ? moment(item?.date).format("LL")
                                            : "No Date"}{" "}
                                        </Text>
                                      </Td>
                                      <Td>
                                        {" "}
                                        {item.status == "paid" ? (
                                          <Badge colorScheme={"green"}>
                                            <Flex>
                                              {item.status.replace("_", "  ")}
                                            </Flex>
                                          </Badge>
                                        ) : null}
                                        {item.status == "partially_paid" ? (
                                          <Badge
                                            variant="outline"
                                            colorScheme={"green"}
                                          >
                                            <Flex>
                                              {item.status.replace("_", "  ")}
                                            </Flex>
                                          </Badge>
                                        ) : null}
                                        {item.status != "partially_paid" &&
                                          item.status != "paid" && (
                                            <Badge
                                              variant="outline"
                                              colorScheme={"green"}
                                            >
                                              <Flex>
                                                {item.status.replace("_", "  ")}
                                              </Flex>
                                            </Badge>
                                          )}
                                      </Td>
                                      <Td fontWeight={600}>
                                        {" "}
                                        {item.balance > 0 ? (
                                          <Badge
                                            variant="outline"
                                            colorScheme={"red"}
                                          >
                                            <Flex>
                                              <Text>AED {item.balance}</Text>
                                            </Flex>
                                          </Badge>
                                        ) : (
                                          <Text fontWeight={900}>
                                            AED {item.balance}
                                          </Text>
                                        )}
                                      </Td>
                                    </Tr>
                                  ))}
                                </Tbody>
                              </Table>
                            </TableContainer>
                          </Box>
                        )}
                        {paymentDetails.length !== 0 && (
                          <Flex flexDir={"column"} mt={4}>
                            <Flex mb={3}>
                              <Tooltip label={"All payments history "}>
                                <Heading size={"sm"}>Payments History</Heading>
                              </Tooltip>
                            </Flex>
                            <TableContainer
                              sx={{
                                "&::-webkit-scrollbar": {
                                  width: "16px",
                                  borderRadius: "8px",
                                  backgroundColor: `rgba(0, 0, 0, 0.05)`,
                                },
                                "&::-webkit-scrollbar-thumb": {
                                  backgroundColor: `rgba(0, 0, 0, 0.05)`,
                                  height: "5px",
                                  width: "5px",
                                },
                              }}
                            >
                              <Table variant="simple" overflow={"auto"}>
                                <Thead>
                                  <Tr>
                                    <Th>Invoice Number</Th>
                                    <Th>Payment Mode</Th>
                                    <Th>Transaction Id</Th>
                                    <Th>Date</Th>
                                    <Th>Amount</Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {paymentDetails?.map((item, index) => (
                                    <Tr key={index}>
                                      <Td>
                                        <Flex
                                          flexDir={"row"}
                                          justifyContent={"center"}
                                          alignItems={"center"}
                                        >
                                          <Flex>
                                            <Text>{item.invoiceNumber}</Text>
                                          </Flex>
                                          <Flex
                                            ml={1}
                                            cursor={"pointer"}
                                            onClick={() =>
                                              copyData(item.invoiceNumber)
                                            }
                                          >
                                            <MdContentCopy />
                                          </Flex>
                                        </Flex>
                                      </Td>
                                      <Td>{item?.paymentMode}</Td>
                                      <Td> {item?.transactionId}</Td>
                                      <Td>
                                        {" "}
                                        {item?.stamp
                                          ? moment(item?.stamp).format("LL")
                                          : "No Date"}
                                      </Td>
                                      <Td fontWeight={600}>
                                        {" "}
                                        AED {item?.paidAmount}
                                      </Td>
                                    </Tr>
                                  ))}
                                </Tbody>
                              </Table>
                            </TableContainer>
                          </Flex>
                        )}

                        {orderDetails?.installmentInfo?.length !== 0 && (
                          <Flex flexDir={"column"} pt={5}>
                            <Flex
                              py={3}
                              flexDir={"row"}
                              justifyContent={"space-between"}
                            >
                              <Flex>
                                <Tooltip
                                  label={
                                    orderDetails?.installmentInfo?.length === 6
                                      ? "6 Months EMI Payments Schedule"
                                      : "3 Months EMI Payments Schedule"
                                  }
                                >
                                  <Heading size={"sm"}>
                                    Payment Schedule
                                  </Heading>
                                </Tooltip>
                              </Flex>

                              {orderDetails?.installmentInfo?.length &&
                              orderDetails?.tenure ? (
                                <Heading size={"sm"}>
                                  {" "}
                                  <Flex>
                                    <Flex>
                                      <Text>
                                        {orderDetails?.tenure ||
                                          orderDetails?.installmentInfo
                                            ?.length}{" "}
                                        Months EMI
                                      </Text>
                                    </Flex>
                                    <Flex>
                                      {orderDetails?.isAddon && (
                                        <>
                                          <Flex
                                            ml={2}
                                            flexDir={"row"}
                                            alignItems={"center"}
                                          >
                                            <Text color={"#e24379"}>
                                              with WIFI Addon
                                            </Text>
                                          </Flex>
                                        </>
                                      )}
                                    </Flex>
                                  </Flex>{" "}
                                </Heading>
                              ) : null}
                            </Flex>
                            <TableContainer>
                              <Table variant="simple">
                                <Thead>
                                  <Tr>
                                    <Th>Amount</Th>
                                    <Th>Due Date</Th>
                                    <Th isNumeric>Status</Th>
                                  </Tr>
                                </Thead>
                                <Tbody>
                                  {orderDetails?.installmentInfo?.length !== 0
                                    ? orderDetails?.installmentInfo?.map(
                                        (item, i) => (
                                          <Tooltip
                                            key={i}
                                            label={`AED ${
                                              item?.price
                                            } to be paid on ${moment
                                              .utc(item?.dueDate)
                                              .format(
                                                "MMMM Do YYYY, h:mm:ss a"
                                              )}`}
                                          >
                                            <Tr>
                                              <Td fontWeight={600}>
                                                AED {item?.price}
                                              </Td>
                                              <Td>
                                                {moment
                                                  .utc(item?.dueDate)
                                                  .format("LL")}
                                              </Td>
                                              <Td isNumeric>
                                                {" "}
                                                {item?.status ===
                                                "EMI OVERDUE" ? (
                                                  <Badge
                                                    variant={"outline"}
                                                    colorScheme={"red"}
                                                  >
                                                    {item?.status || "Pending"}
                                                  </Badge>
                                                ) : (
                                                  <Badge
                                                    variant={"outline"}
                                                    colorScheme={
                                                      item?.status === "PAID"
                                                        ? "green"
                                                        : "gray"
                                                    }
                                                  >
                                                    {item?.status || "Pending"}
                                                  </Badge>
                                                )}
                                              </Td>
                                            </Tr>
                                          </Tooltip>
                                        )
                                      )
                                    : null}
                                </Tbody>
                              </Table>
                            </TableContainer>
                          </Flex>
                        )}
                      </Flex>
                    </Skeleton>
                  </GridItem>

                  <GridItem
                    rowSpan={1}
                    colSpan={{ base: 4, md: 3, lg: 3, "2xl": 2 }}
                  >
                    <Skeleton
                      isLoaded={!loading}
                      fadeDuration={1.5}
                      borderRadius={20}
                    >
                      <Flex __css={styles} background={"transparent"}>
                        <VerticalTimeline
                          lineColor={timeLineBox}
                          layout={"1-column-left"}
                        >
                          {historyOrder.length !== 0
                            ? historyOrder.map((item, i) => (
                                <VerticalTimelineElement
                                  key={i}
                                  contentStyle={{
                                    background: "transparent",

                                    color: textColor,
                                  }}
                                  iconStyle={{
                                    background: "rgb(51, 62, 96)",
                                    color: "#fff",
                                  }}
                                  icon={<AiOutlineDeploymentUnit />}
                                >
                                  <h3>
                                    {moment(item.stamp).format(
                                      "MMMM Do YYYY, h:mm:ss a"
                                    )}
                                  </h3>
                                  <Flex>
                                    <h4>
                                      {item.status.charAt(0).toUpperCase() +
                                        item.status.slice(1)}
                                    </h4>
                                  </Flex>
                                  <p>{item.comment}</p>
                                </VerticalTimelineElement>
                              ))
                            : null}
                        </VerticalTimeline>
                      </Flex>
                    </Skeleton>
                  </GridItem>
                </Grid>
              </DrawerBody>
            </DrawerContent>
          </Drawer>
          {/* EID Front Modal */}
          <Modal
            isOpen={isFrontOpen}
            onClose={() => {
              onFrontClose();
              setFrontRotation(0);
              setFrontZoom(1);
              setFrontPanOffset({ x: 0, y: 0 });
            }}
            size="xl"
            isCentered
          >
            <ModalOverlay />
            <ModalContent
              h="100vh"
              maxH="100vh"
              display="flex"
              flexDirection="column"
              overflow="hidden"
            >
              <ModalHeader>EID Front</ModalHeader>
              <ModalCloseButton />
              <ModalBody
                flex="1"
                display="flex"
                alignItems="center"
                justifyContent="center"
                overflow="auto"
                p={0}
                position="relative"
              >
                <Box
                  position="relative"
                  onWheel={(e) => handleImageWheel(e, false)}
                  onMouseDown={(e) => handleMouseDown(e, false)}
                  onMouseMove={(e) => handleMouseMove(e, false)}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseUp}
                  cursor={
                    frontZoom > 1
                      ? isDragging
                        ? "grabbing"
                        : "grab"
                      : "zoom-in"
                  }
                >
                  <Image
                    src={`data:image/jpeg;base64,${userDetails?.emiratesProfile?.eidaFrontBase64}`}
                    alt="EID Front Full"
                    maxH={frontZoom > 1 ? "none" : "100%"}
                    maxW={frontZoom > 1 ? "none" : "100%"}
                    objectFit="contain"
                    style={{
                      transform: `translate(${frontPanOffset.x}px, ${frontPanOffset.y}px) scale(${frontZoom}) rotate(${frontRotation}deg)`,
                      transition: isDragging ? "none" : "transform 0.1s ease",
                    }}
                    userSelect="none"
                    draggable={false}
                    pointerEvents="none"
                  />
                </Box>
                <Text
                  position="absolute"
                  bottom={4}
                  left="50%"
                  transform="translateX(-50%)"
                  bg="blackAlpha.700"
                  color="white"
                  px={3}
                  py={1}
                  borderRadius="md"
                  fontSize="sm"
                  pointerEvents="none"
                >
                  Use mouse wheel to zoom • Current:{" "}
                  {(frontZoom * 100).toFixed(0)}%
                </Text>
              </ModalBody>
              <ModalFooter>
                <Button
                  onClick={() => setFrontRotation((prev) => (prev + 90) % 360)}
                  leftIcon={<MdRotateRight />}
                  variant="outline"
                  mr={2}
                >
                  Rotate
                </Button>
                <Button
                  onClick={() =>
                    downloadImage(
                      userDetails?.emiratesProfile?.eidaFrontBase64,
                      `EID_Front_${
                        userDetails?.emiratesProfile?.emiratesId || "unknown"
                      }.jpg`
                    )
                  }
                  leftIcon={<MdDownload />}
                  variant="outline"
                  mr={3}
                >
                  Download
                </Button>
                <Button
                  onClick={() => {
                    onFrontClose();
                    setFrontRotation(0);
                    setFrontZoom(1);
                    setFrontPanOffset({ x: 0, y: 0 });
                  }}
                >
                  Close
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          {/* EID Back Modal */}
          <Modal
            isOpen={isBackOpen}
            onClose={() => {
              onBackClose();
              setBackRotation(0);
              setBackZoom(1);
              setBackPanOffset({ x: 0, y: 0 });
            }}
            size="xl"
            isCentered
          >
            <ModalOverlay />
            <ModalContent
              h="100vh"
              maxH="100vh"
              display="flex"
              flexDirection="column"
              overflow="hidden"
            >
              <ModalHeader>EID Back</ModalHeader>
              <ModalCloseButton />
              <ModalBody
                flex="1"
                display="flex"
                alignItems="center"
                justifyContent="center"
                overflow="auto"
                p={0}
                position="relative"
              >
                <Box
                  position="relative"
                  onWheel={(e) => handleImageWheel(e, true)}
                  onMouseDown={(e) => handleMouseDown(e, true)}
                  onMouseMove={(e) => handleMouseMove(e, true)}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseUp}
                  cursor={
                    backZoom > 1
                      ? isDragging
                        ? "grabbing"
                        : "grab"
                      : "zoom-in"
                  }
                >
                  <Image
                    src={`data:image/jpeg;base64,${userDetails?.emiratesProfile?.eidaBackBase64}`}
                    alt="EID Back Full"
                    maxH={backZoom > 1 ? "none" : "100%"}
                    maxW={backZoom > 1 ? "none" : "100%"}
                    objectFit="contain"
                    style={{
                      transform: `translate(${backPanOffset.x}px, ${backPanOffset.y}px) scale(${backZoom}) rotate(${backRotation}deg)`,
                      transition: isDragging ? "none" : "transform 0.1s ease",
                    }}
                    userSelect="none"
                    draggable={false}
                    pointerEvents="none"
                  />
                </Box>
                <Text
                  position="absolute"
                  bottom={4}
                  left="50%"
                  transform="translateX(-50%)"
                  bg="blackAlpha.700"
                  color="white"
                  px={3}
                  py={1}
                  borderRadius="md"
                  fontSize="sm"
                  pointerEvents="none"
                >
                  Use mouse wheel to zoom • Current:{" "}
                  {(backZoom * 100).toFixed(0)}%
                </Text>
              </ModalBody>
              <ModalFooter>
                <Button
                  onClick={() => setBackRotation((prev) => (prev + 90) % 360)}
                  leftIcon={<MdRotateRight />}
                  variant="outline"
                  mr={2}
                >
                  Rotate
                </Button>
                <Button
                  onClick={() =>
                    downloadImage(
                      userDetails?.emiratesProfile?.eidaBackBase64,
                      `EID_Back_${
                        userDetails?.emiratesProfile?.emiratesId || "unknown"
                      }.jpg`
                    )
                  }
                  leftIcon={<MdDownload />}
                  variant="outline"
                  mr={3}
                >
                  Download
                </Button>
                <Button
                  onClick={() => {
                    onBackClose();
                    setBackRotation(0);
                    setBackZoom(1);
                    setBackPanOffset({ x: 0, y: 0 });
                  }}
                >
                  Close
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          {/* Add Confirmation Modal */}
          <Modal isOpen={isConfirmOpen} onClose={handleCancelUpdate} isCentered>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Confirm Order Update</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Text mb={4}>Are you sure you want to update this order?</Text>

                {orderStatusUpdate && (
                  <Text mb={4} fontSize="sm" color="gray.600">
                    Status will be changed to:{" "}
                    <strong>{capitalizeFirstLetter(orderStatusUpdate)}</strong>
                  </Text>
                )}

                {salesAgentUpdate && (
                  <Text mb={4} fontSize="sm" color="gray.600">
                    Sales Agent will be changed to:{" "}
                    <strong>{salesAgentUpdate}</strong>
                  </Text>
                )}

                <FormControl>
                  <FormLabel>Comment (Optional)</FormLabel>
                  <Textarea
                    placeholder="Add a comment about this update..."
                    value={confirmationComment}
                    onChange={(e) => setConfirmationComment(e.target.value)}
                    rows={4}
                    resize="vertical"
                  />
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button colorScheme="blue" mr={3} onClick={handleConfirmUpdate}>
                  Confirm Update
                </Button>
                <Button onClick={handleCancelUpdate}>Cancel</Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          {/* Address Update Modal */}
          <Modal isOpen={isAddressOpen} onClose={handleCancelAddressUpdate} isCentered>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Update Customer Address</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <FormControl mb={4}>
                  <FormLabel>Zone <Text as="span" color="red.500">*</Text></FormLabel>
                  <Select
                    color={textColor}
                    placeholder="Select Zone"
                    value={addressUpdate.userZone}
                    onChange={(e) =>
                      setAddressUpdate({
                        ...addressUpdate,
                        userZone: e.target.value,
                      })
                    }
                  >
                    {/* Show current value if it's not in predefined options */}
                    {addressUpdate.userZone && !zoneOptions.includes(addressUpdate.userZone) && (
                      <option key={addressUpdate.userZone} value={addressUpdate.userZone}>
                        {addressUpdate.userZone} (Current)
                      </option>
                    )}
                    {zoneOptions.map((zone) => (
                      <option key={zone} value={zone}>
                        {zone}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl mb={4}>
                  <FormLabel>State <Text as="span" color="red.500">*</Text></FormLabel>
                  <Select
                    color={textColor}
                    placeholder="Select State"
                    value={addressUpdate.userZoneState}
                    onChange={(e) =>
                      setAddressUpdate({
                        ...addressUpdate,
                        userZoneState: e.target.value,
                      })
                    }
                  >
                    {/* Show current value if it's not in predefined options */}
                    {addressUpdate.userZoneState && !stateOptions.includes(addressUpdate.userZoneState) && (
                      <option key={addressUpdate.userZoneState} value={addressUpdate.userZoneState}>
                        {addressUpdate.userZoneState} (Current)
                      </option>
                    )}
                    {stateOptions.map((state) => (
                      <option key={state} value={state}>
                        {state}
                      </option>
                    ))}
                  </Select>
                </FormControl>

                <FormControl mb={4}>
                  <FormLabel>Address <Text as="span" color="red.500">*</Text></FormLabel>
                  <Textarea
                    placeholder="Enter customer address..."
                    value={addressUpdate.userAddress}
                    onChange={(e) =>
                      setAddressUpdate({
                        ...addressUpdate,
                        userAddress: e.target.value,
                      })
                    }
                    rows={3}
                    resize="vertical"
                  />
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button colorScheme="blue" mr={3} onClick={handleAddressUpdate}>
                  Update Address
                </Button>
                <Button onClick={handleCancelAddressUpdate}>Cancel</Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          {/* Lock Device Confirmation Modal */}
          <Modal isOpen={isLockConfirmOpen} onClose={onLockConfirmClose} isCentered size="lg">
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Confirm Lock Device</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Text mb={4}>
                  Are you sure you want to lock this device? The following message will be sent to the customer:
                </Text>

                <FormControl>
                  <FormLabel>Lock Message</FormLabel>
                  <Textarea
                    placeholder="Enter lock message..."
                    value={lockMessage}
                    onChange={(e) => setLockMessage(e.target.value)}
                    rows={6}
                    resize="vertical"
                  />
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button
                  colorScheme="red"
                  mr={3}
                  onClick={handleLockDevice}
                  isLoading={lockUnlockLoading}
                >
                  Confirm Lock
                </Button>
                <Button onClick={onLockConfirmClose} isDisabled={lockUnlockLoading}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>

          {/* Unlock Device Confirmation Modal */}
          <Modal isOpen={isUnlockConfirmOpen} onClose={onUnlockConfirmClose} isCentered>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader>Confirm Unlock Device</ModalHeader>
              <ModalCloseButton />
              <ModalBody pb={6}>
                <Text mb={4}>
                  Are you sure you want to unlock this device? The following message will be sent to the customer:
                </Text>

                <FormControl>
                  <FormLabel>Unlock Message</FormLabel>
                  <Textarea
                    placeholder="Enter unlock message..."
                    value={unlockMessage}
                    onChange={(e) => setUnlockMessage(e.target.value)}
                    rows={3}
                    resize="vertical"
                  />
                </FormControl>
              </ModalBody>

              <ModalFooter>
                <Button
                  colorScheme="green"
                  mr={3}
                  onClick={handleUnlockDevice}
                  isLoading={lockUnlockLoading}
                >
                  Confirm Unlock
                </Button>
                <Button onClick={onUnlockConfirmClose} isDisabled={lockUnlockLoading}>
                  Cancel
                </Button>
              </ModalFooter>
            </ModalContent>
          </Modal>
        </>
      )}
    </>
  );
}

export default OrderDrawer;
